export const PLANNING_FETCH = 'PLANNING_FETCH'
export const PLANNING_FETCH_SUCCESS = 'PLANNING_FETCH_SUCCESS'
export const PLANNING_FETCH_FAILED = 'PLANNING_FETCH_FAILED'

export const UPDATE_PLANNING = 'UPDATE_PLANNING'
export const UPDATE_PLANNING_SUCCESS = 'UPDATE_PLANNING_SUCCESS'
export const UPDATE_PLANNING_FAILED = 'UPDATE_PLANNING_FAILED'

export const PLANNING_DATA_FETCH = 'PLANNING_DATA_FETCH'
export const PLANNING_DATA_FETCH_SUCCESS = 'PLANNING_DATA_FETCH_SUCCESS'
export const PLANNING_DATA_FETCH_FAILED = 'PLANNING_DATA_FETCH_FAILED'

export const PLANNING_EVENT_CHANGE = 'PLANNING_EVENT_CHANGE'
export const PLANNING_EVENT_CHANGE_SUCCESS = 'PLANNING_EVENT_CHANGE_SUCCESS'
export const PLANNING_EVENT_CHANGE_FAILED = 'PLANNING_EVENT_CHANGE_FAILED'

export const SET_COLORS = 'SET_COLORS'
export const SET_COLORS_SUCCESS = 'SET_COLORS_SUCCESS'
export const SET_COLORS_FAILED = 'SET_COLORS_FAILED'

export const PLANNING_DELETE = 'PLANNING_DELETE'
export const PLANNING_DELETE_SUCCESS = 'PLANNING_DELETE_SUCCESS'
export const PLANNING_DELETE_FAILED = 'PLANNING_DELETE_FAILED'

export const PLANNING_RESET = 'PLANNING_RESET'
